<div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
    <div fxLayoutAlign="flex-start center" class="mb-12 shrink-0">
        <h3 class="my-0">{{ 'USER.PLURAL' | translate }}</h3>
    </div>

    <div class="w-100-p table-wrapper">
        <ng-container *ngIf="hasUsers; else noUsersAvailableState">
            <mat-table #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="avatar">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let member">
                        <div class="relative" #avatarCell>
                            <img class="avatar" *ngIf="member.profilePicture?.src; else initials" [alt]="member.fullName" [src]="member.profilePicture?.src" />
                            <ng-template #initials>
                                <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ member.fullName | initials }}</div>
                            </ng-template>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="firstName">
                    <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                        {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="narrow">
                        <p class="text-truncate font-semibold">
                            {{ member.firstName }}
                        </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="lastName">
                    <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                        {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let member" class="narrow">
                        <p class="text-truncate font-semibold">
                            {{ member.lastName }}
                        </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email">
                    <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                        {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let member" fxHide fxShow.gt-xs>
                        <p class="text-truncate font-semibold">{{ member.email }}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let member">
                        <div fxFlex="row" fxLayoutAlign="end center">
                            <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(member)" *ngIf="!member.alreadyMember"></app-flat-button>
                            <app-white-button
                                [label]="'GENERAL.BUTTON.UNSELECT'"
                                (onClick)="removeFromList(member)"
                                *ngIf="member.alreadyMember"
                            ></app-white-button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let member; columns: displayedColumns" class="member" matRipple></mat-row>
            </mat-table>
        </ng-container>
    </div>
</div>

<ng-template #noUsersAvailableState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="participant-view-illustration" svgIcon="user_illustration"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
    </div>
</ng-template>
